import React, { useEffect, useMemo, useState } from "react";
import { Accordion, Card, Collapse } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Table from "../../components/table/Table";
import { badge } from "../../components/common/Utils";
import {
  ArrowBarLeft,
  ArrowBarRight,
  ArrowClockwise,
  ArrowLeftShort,
  FilterCircle,
  PlusCircle,
  PrinterFill,
} from "react-bootstrap-icons";
import Loader from "../../components/common/Loader";
import { useDispatch, useSelector } from "react-redux";
import { FontColor, FourGround } from "../../assets/js/theme";
import Footer from "../../components/admin/footer/Footer";
import { getHotspotVoucher } from "../../features/hotspotApi";
import useISPowner from "../../hooks/useISPOwner";
import moment from "moment";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../assets/css/dash.module.css";
import { useNavigate } from "react-router-dom";
import VoucherFormDialog from "./VoucherFormDialog";
import PrintVoucher from "./PrintVoucher";

const HotspotVoucher = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  const vouchers = useSelector((state) => state.hotspot?.voucher);

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);
  const [activeKeys, setActiveKeys] = useState("");
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getHotspotVoucher(dispatch, ispOwnerId, setIsLoading);
  }, []);

  const columns = useMemo(
    () => [
      {
        width: "13%",
        Header: t("code"),
        accessor: "customerId",
      },
      {
        width: "13%",
        Header: t("name"),
        accessor: "name",
      },
      {
        width: "16%",
        Header: t("package"),
        accessor: "hotspot.profile",
      },
      {
        width: "10%",
        Header: t("bill"),
        accessor: "monthlyFee",
      },
      {
        width: "16%",
        Header: t("expired"),
        accessor: "billingCycle",
        Cell: ({ row: { original } }) => {
          return (
            ["active", "expired"].includes(original?.status) &&
            moment(original.billingCycle).format("YYYY/MM/DD hh:mm A")
          );
        },
      },
      {
        width: "10%",
        Header: t("status"),
        accessor: "status",
        Cell: ({ cell: { value } }) => badge(value),
      },
      //   {
      //     width: "7%",
      //     Header: () => <div className="text-center">{t("action")}</div>,
      //     id: "option",
      //     Cell: ({ row: { original } }) => (
      //       <div className="d-flex justify-content-center align-items-center">
      //         <div className="dropdown">
      //           <ThreeDots
      //             className="dropdown-toggle ActionDots"
      //             id="areaDropdown"
      //             type="button"
      //             data-bs-toggle="dropdown"
      //             aria-expanded="false"
      //           />
      //           <ul className="dropdown-menu" aria-labelledby="resellerDropdown">
      //             <li
      //               onClick={() => {
      //                 setInvoiceTabs("createInvoice");
      //                 setInvoice(original);
      //                 setIsUpdate(true);
      //               }}
      //             >
      //               <div className="dropdown-item">
      //                 <div className="customerAction">
      //                   <PenFill />
      //                   <p className="actionP">{t("edit")}</p>
      //                 </div>
      //               </div>
      //             </li>

      //             <li
      //               onClick={() => {
      //                 setInvoice(original);
      //                 setModalStatus("recharge");
      //                 setNewShow(true);
      //               }}
      //             >
      //               <div className="dropdown-item">
      //                 <div className="customerAction">
      //                   <CashStack />
      //                   <p className="actionP">{t("collection")}</p>
      //                 </div>
      //               </div>
      //             </li>
      //           </ul>
      //         </div>
      //       </div>
      //     ),
      //   },
    ],
    [t]
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="d-flex align-items-center gap-2">
                    <ArrowLeftShort
                      size={30}
                      className="arrowLeftRightButton"
                      onClick={() => navigate(-1)}
                    />

                    <p className="component_name">{t("voucher")}</p>
                  </div>

                  <div
                    style={{ height: "45px" }}
                    className="d-flex align-items-center"
                  >
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          // onClick={reloadHandler}
                        />
                      )}
                    </div>

                    <div className="addAndSettingIcon">
                      <PlusCircle
                        className="addcutmButton"
                        title={t("voucher")}
                        onClick={() => {
                          setModalStatus("voucher");
                          setShow(true);
                        }}
                      />
                    </div>

                    <Collapse in={open} dimension="width">
                      <div id="example-collapse-text">
                        <Card className="cardCollapse border-0">
                          <div className="d-flex align-items-center">
                            <div className="addAndSettingIcon">
                              <PrinterFill
                                title={t("print")}
                                className="addcutmButton"
                                onClick={() => {
                                  setModalStatus("print");
                                  setShow(true);
                                }}
                              />
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Collapse>

                    {!open && (
                      <ArrowBarLeft
                        className="ms-1"
                        size={34}
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      />
                    )}

                    {open && (
                      <ArrowBarRight
                        className="ms-1"
                        size={34}
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      />
                    )}
                  </div>
                </div>
              </FourGround>
              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        {/* <DataFilter
                            page="hotspot"
                            filterData={customer}
                            setFilterData={setHotspotCustomers}
                            filterOptions={filterOptions}
                            setFilterOption={setFilterOption}
                            inputPermission={filterInputPermission}
                          /> */}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="collectorWrapper pb-2">
                    <Table
                      isLoading={isLoading}
                      columns={columns}
                      data={vouchers}
                    />
                  </div>
                </div>
              </FourGround>

              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {/* Voucher create dialog */}
      {modalStatus === "voucher" && (
        <VoucherFormDialog {...{ show, setShow }} />
      )}

      {/* Voucher print options dialog */}
      {modalStatus === "print" && (
        <PrintVoucher {...{ show, setShow, vouchers }} />
      )}
    </>
  );
};

export default HotspotVoucher;
